$(function () {
    $('#cookie_info').each(function () {
        var value = EUCUtils.readCookie('canDoCookies');
        if (value == null) {
            $(this).removeClass('d-none');
        }
    });
    $('#btn_cookie').on('click', function () {
        EUCUtils.createCookie('canDoCookies', '1', 3650);
        $('#cookie_info').addClass('d-none');
    });
});